import {CashFlowService} from '@/common/api/cash-flow.service'
import {
    CASH_FLOW_CREATE,
    CASH_FLOW_EDIT,
    CASH_FLOW_DELETE,
    CASH_FLOW_GET,
    CASH_FLOWS_GET,
    CASH_FLOWS_BM_GET,
    CASH_FLOW_ACTIVE,
    CASH_FLOW_INACTIVE,
    CASH_FLOW_SEARCH, CASH_FLOWS_SIMPLE_BM_GET, 
} from './actions/cash-flow.type.js'
import {
    SET_CASH_FLOW,
    SET_CASH_FLOWS,
    SET_CASH_FLOW_PAGINATION,
    SET_CASH_FLOW_ACTIVE,
    CASH_FLOW_RESET,
    CASH_FLOW_RESET_STATE, SET_CASH_FLOWS_SIMPLE,
} from './mutations/cash-flow.type.js'

import {CHANGE_PROGRESS} from './mutations/mutations.type.js'

const initialState = () => {
    return {
        cashFlow: {
            id: 0,
            active: false,
            name: "",
            desc: "",
            value: null,
            categoryID: 0,
            categoryName: "",

        },

        cashFlowPagination: {
            startDate:null,
            endDate:null,
            search: "",
            account: null,
            itemsPerPage: 10,
            orderBy: "",
            sortDesc: false,
        },

        itemsPerPage: 10,
        cashFlows: {
            active: true,
            activePage: 1,
            totalPages: 1,
            totalItems: 1,
            credito: 0,
            debito:0,
            startDate:"",
            endDate:"",
            items: []
        },
        cashFlowsSimple: [],
        categories: [],

    }
}

export const state = initialState()

const getters = {
    cashFlow: state => {
        return state.cashFlow
    },
    cashFlows: state => {
        return state.cashFlows
    },
    cashFlowsSimple: state => {
        return state.cashFlowsSimple
    },
    cashFlowPagination: state => {
        return state.cashFlowPagination
    },
    categories: state => {
        return state.categories
    }
}

export const mutations = {
    [SET_CASH_FLOW](state, data) {
        state.cashFlow = data
    },
    [SET_CASH_FLOWS](state, data) {
        state.cashFlows = data
    },
    [SET_CASH_FLOWS_SIMPLE](state, data) {
        state.cashFlowsSimple = data
    },

    // [SET_CATEGORIES](state, data) {
    //     state.categories = data
    // },
    [SET_CASH_FLOW_PAGINATION](state, data) {
        state.cashFlows.activePage = data.page
        state.cashFlowPagination.itemsPerPage = data.itemsPerPage
        state.cashFlowPagination.orderBy = data.orderBy
        state.cashFlowPagination.sortDesc = data.sortDesc
        state.cashFlowPagination.endDate = data.endDate
        state.cashFlowPagination.startDate = data.startDate
    },
    [SET_CASH_FLOW_ACTIVE](state, active) {
        state.cashFlow.active = active
    },
    [CASH_FLOW_RESET](state) {
        Object.assign(state.cashFlow, initialState().cashFlow)
    },
    [CASH_FLOW_RESET_STATE](state) {
        Object.assign(state, initialState())
    },
}

export const actions = {
    // async [CATEGORIES_GET]({commit}) {
    //     commit(CHANGE_PROGRESS, true)
    //     const {data} = await ServiceService.list_categories()
    //     commit(SET_CATEGORIES, data)
    //     commit(CHANGE_PROGRESS, false)
    // },
    async [CASH_FLOWS_GET]({commit}) {
        commit(CHANGE_PROGRESS, true)
        const {data} = await CashFlowService.list()
        commit(SET_CASH_FLOWS_SIMPLE, data)
        commit(CHANGE_PROGRESS, false)
    },
    async [CASH_FLOWS_SIMPLE_BM_GET]({commit}, id) {
        commit(CHANGE_PROGRESS, true)
        const {data} = await CashFlowService.listBM(id)
        commit(SET_CASH_FLOWS_SIMPLE, data)
        commit(CHANGE_PROGRESS, false)
    },

    async [CASH_FLOW_GET]({commit}, id) {
        commit(CHANGE_PROGRESS, true)
        const {data} = await CashFlowService.get(id)
        commit(SET_CASH_FLOW, data)
        commit(CHANGE_PROGRESS, false)
    },
    async [CASH_FLOWS_BM_GET]({commit}, id) {
        commit(CHANGE_PROGRESS, true)
        const {data} = await CashFlowService.bmServices(id)
        commit(SET_CASH_FLOWS_SIMPLE, data)
        commit(CHANGE_PROGRESS, false)
    },

    async [CASH_FLOW_SEARCH]({commit, state}) {
        let accountType = ""
        let account = 0
        if ( state.cashFlowPagination.account != null) {
            accountType = state.cashFlowPagination.account.accountCategory.charAt(0)
            account = state.cashFlowPagination.account.id
        }
        commit(CHANGE_PROGRESS, true)
        const {data} = await CashFlowService.search(
            state.cashFlows.activePage,
            state.cashFlowPagination.itemsPerPage,
            accountType,
            account,
            state.cashFlowPagination.search,
            state.cashFlowPagination.orderBy,
            state.cashFlowPagination.sortDesc,
            state.cashFlowPagination.startDate,
            state.cashFlowPagination.endDate)
        commit(SET_CASH_FLOWS, data)
        commit(CHANGE_PROGRESS, false)
    },
    [CASH_FLOW_CREATE]({state}) {
        return CashFlowService.create(state.cashFlow)
    },
    [CASH_FLOW_EDIT]({state}) {
        return CashFlowService.update("", state.cashFlow)
    },
    [CASH_FLOW_ACTIVE](_, id) {
        return CashFlowService.active(id)
    },
    [CASH_FLOW_INACTIVE](_, id) {
        return CashFlowService.inactive(id)
    },
    [CASH_FLOW_DELETE]({state}) {
        return CashFlowService.delete(state.cashFlow.id)
    },
    [CASH_FLOW_RESET_STATE]({commit}) {
        commit(CASH_FLOW_RESET_STATE)
    }
}
export default {
    state,
    actions,
    mutations,
    getters
}
